
                  export default function (Component) {
                      Component.__source = "library/components/VabMenu/index.vue"
                  }
              